/* eslint-disable ember/no-classic-components, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { action } from '@ember/object';
// Internal Imports

export default class FieldTransfer extends Component {
  // Services
  @service
  store;

  @service
  toaster;

  @tracked
  permissionReply = null;
  @tracked
  person = null;
  selectedFields = [];
  @tracked
  dialogOpen = false;

  @action
  openDialog() {
    this.store
      .query('events/permission-reply', {
        schoolId: this.permissionReply.event.get('school.id'),
        eventId: this.permissionReply.event.get('id'),
        personId: this.permissionReply.person.get('id'),
      })
      .then((replies) => {
        if (replies.length) {
          this.permissionReply = replies
            .slice()
            .sort((a, b) =>
              a.createTime > b.createTime
                ? 1
                : a.createTime < b.createTime
                  ? -1
                  : 0,
            )
            .reverse()[0];
          this.store
            .findRecord('person', this.permissionReply.person.get('id'))
            .then((person) => {
              if (person) {
                this.person = person;
              }
            });
        }
        this.dialogOpen = true;
      });
  }

  @action
  transfer() {
    this.selectedFields.forEach((field) => {
      if (this.permissionReply.fields[field.key]) {
        if (isEmpty(this.person.fields[field.key])) {
          // This field doesn't exist on the Person.  Add it.
          this.person.addField(field.key, field.dataType);
        }
        this.person.fields.set(
          `${field.key}.value`,
          this.permissionReply.fields[field.key].get('value'),
        );
      }
    });
    this.person
      .save()
      .then(() => {
        this.toaster.success('Student updated successfully!');
      })
      .catch(() => {
        this.toaster.error('Student update failed!');
      })
      .finally(() => {
        this.dialogOpen = false;
      });
  }
}
